module.exports = __webpack_public_path__ + "static/UNA-7995a69404af841731f57312f494f0c1.png";